export enum Event {
  AUTH_INIT = 'AUTH_INIT',
  SHARE_VEHICLES_DATA = 'SHARE_VEHICLES_DATA',
  EXECUTE_ADVANCED_TRANSACTION = 'EXECUTE_ADVANCED_TRANSACTION',
  SIGN_MESSAGE = 'SIGN_MESSAGE',
}

export enum EventByUiState {
  VEHICLE_MANAGER = Event.SHARE_VEHICLES_DATA,
  ADVANCED_TRANSACTION = Event.EXECUTE_ADVANCED_TRANSACTION,
  SIGN_MESSAGE = Event.SIGN_MESSAGE,
}
